<template>
    <div class="app-container">

        <el-table v-loading="loading" :data="zhekouList" @selection-change="handleSelectionChange">
            <el-table-column label="1-3个月(折)" align="center" prop="yi" />
            <el-table-column label="4-6个月(折)" align="center" prop="er" />
            <el-table-column label="7-9个月(折)" align="center" prop="san" />
            <el-table-column label="10-12个月(折)" align="center" prop="si" />
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="text"
                        icon="el-icon-edit"
                        @click="handleUpdate(scope.row)"
                        v-hasPermi="['fang:zhekou:edit']"
                    >修改</el-button>
                </template>
            </el-table-column>
        </el-table>



        <!-- 添加或修改折扣对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item label="1-3个月(折)">
                    <el-input v-model="form.yi"/>
                </el-form-item>
                <el-form-item label="4-6个月(折)">
                    <el-input v-model="form.er" />
                </el-form-item>
                <el-form-item label="7-9个月(折)">
                    <el-input v-model="form.san"/>
                </el-form-item>
                <el-form-item label="10-12个月(折)">
                    <el-input v-model="form.si" />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { listZhekou, getZhekou, delZhekou, addZhekou, updateZhekou } from "@/api/homestay/api";

export default {
    name: "Zhekou",
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 折扣表格数据
            zhekouList: [],
            // 弹出层标题
            title: "",
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                jiDuName: null,
                yi: null,
                er: null,
                san: null,
                si: null,
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    { required: true, message: "$comment不能为空", trigger: "blur" }
                ],
                jiDuName: [
                    { required: true, message: "季度名称不能为空", trigger: "blur" }
                ],
                yi: [
                    { required: true, message: "0-3不能为空", trigger: "blur" }
                ],
                er: [
                    { required: true, message: "3-6不能为空", trigger: "blur" }
                ],
                san: [
                    { required: true, message: "6-9不能为空", trigger: "blur" }
                ],
                si: [
                    { required: true, message: "9-12不能为空", trigger: "blur" }
                ],
                delFlag: [
                    { required: true, message: "删除标志不能为空", trigger: "blur" }
                ],
            }
        };
    },
    created() {
        this.getList();
    },
    methods: {
        /** 查询折扣列表 */
        getList() {
            this.loading = true;
            listZhekou(this.queryParams).then(response => {
                this.zhekouList = response.data;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                jiDuName: null,
                yi: null,
                er: null,
                san: null,
                si: null,
                delFlag: null,
            };
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length!==1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加折扣";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const ids = row.id || this.ids.join(',')
            getZhekou({'id': ids}).then(response => {
                this.form = response.data;
                this.open = true;
                this.title = "修改折扣";
            });
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        updateZhekou(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addZhekou(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const ids = row.id || this.ids.join(',');
            this.$modal.confirm('是否确认删除折扣编号为"' + ids + '"的数据项？').then(function() {
                return delZhekou(ids);
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {});
        },
        /** 导出按钮操作 */
        handleExport() {
            this.download('fang/zhekou/export', {
                ...this.queryParams
            }, `zhekou_${new Date().getTime()}.xlsx`)
        }
    }
};
</script>
